import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension/logOnlyInProduction";
import logger from "redux-logger";
import promise from "redux-promise-middleware";
import thunk from "redux-thunk";

import rootReducer from "./reducers";

export const initialState = {
  auth: {
    user: null,
    fetching: false,
    error: false
  },
  users: {
    users: null,
    fetching: false,
    error: false
  },
  customization: {
    styleType: "light"
  },
  devices: []
};

const store = createStore(
  rootReducer,
  initialState,
  composeWithDevTools(applyMiddleware(thunk, promise, logger))
);

// const persistor = persistStore(store);

export default store;
